export const BookingsIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 8.4H3M13.1111 2V5.2M6.88889 2V5.2M7.66667 13.2L9.22222 14.8L12.7222 11.2M6.73333 18H13.2667C14.5735 18 15.2269 18 15.726 17.7384C16.165 17.5083 16.522 17.1412 16.7457 16.6896C17 16.1762 17 15.5041 17 14.16V7.44C17 6.09587 17 5.42381 16.7457 4.91042C16.522 4.45883 16.165 4.09168 15.726 3.86158C15.2269 3.6 14.5735 3.6 13.2667 3.6H6.73333C5.42654 3.6 4.77315 3.6 4.27402 3.86158C3.83498 4.09168 3.47802 4.45883 3.25432 4.91042C3 5.42381 3 6.09587 3 7.44V14.16C3 15.5041 3 16.1762 3.25432 16.6896C3.47802 17.1412 3.83498 17.5083 4.27402 17.7384C4.77315 18 5.42654 18 6.73333 18Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
